import { getDefaultName } from '../helper/setDefaultName';

const PROCESSING_STATUS = 1, AVAILABLE_STATUS = 2;
const fileNameErrorTip = "Filename must be 1–20 characters long, start with a letter or number, and may contain only letters, numbers, underscores (_), hyphens (-), dollar signs ($), and parentheses (() and ))."

/**
 * genrate download S-parameter tree list
 * @param {Object} resData: [{
       description,
       fileName,
       headerLines,
       portIndexNameMap: { [index]: [portName] },
       snpUrl,
       transformedSnpInfo,
       status,
     }]
 * @returns {isExistTransforming, treeData: [title, key, nodeInfo, children]}
 */
function generateDownloadSParameterList(resData = []) {
  let isExistTransforming = false;
  const treeData = resData.map((item) => {
    return {
      title: item.fileName,
      key: item.snpUrl,
      nodeInfo: item,
      children: item.transformedSnpInfo.map((transformedItem) => {
        if (transformedItem.status === PROCESSING_STATUS) {
          isExistTransforming = true;
        }
        return {
          title: transformedItem.fileName,
          key: transformedItem.snpUrl,
          isTransformFile: true,
          nodeInfo: transformedItem,
        }
      })
    }
  })

  return { isExistTransforming, treeData };
}

/**
 * generate transform S-parameter table data source
 * @param {Object} portIndexNameMap {[index]: [portName]}
 * @returns 
 */
function generateTransformDataSource(portIndexNameMap = {}) {
  return Object.keys(portIndexNameMap).map((key) => {
    return {
      originPortIndex: key,
      originName: portIndexNameMap[key],
      name: portIndexNameMap[key],
    }
  })
}

/**
 * parse upload S-parameter table data source
 * @param {*} dataSource 
 * @param {*} oldDataSource 
 * @returns 
 */
function parseTransformDataSource(dataSource = [], oldDataSource) {
  if (dataSource.length !== oldDataSource.length) {
    return "The file has data loss or data overflow.";
  }

  const maxPortIndex = oldDataSource.length;
  const keyToTitleMap = {
    portIndex: 'Port Index',
    originPortIndex: 'Original Port Index',
    originName: 'Original Name',
    name: 'New Name',
  }

  function checkPortIndex(type) {
    const portIndexArr = dataSource.map(d => d[type]);
    const portIndexSet = new Set(portIndexArr);
    if (portIndexSet.size !== portIndexArr.length) {
      return `The ${keyToTitleMap[type]} is repeated.`
    }
    if (portIndexArr.some(d => d > maxPortIndex || d < 1)) {
      return `The ${keyToTitleMap[type]} is out of range([1, ${maxPortIndex}]).`
    }
  }

  const checkPortIndexError = checkPortIndex('portIndex');
  if (checkPortIndexError) {
    return checkPortIndexError;
  }

  const checkOriginPortIndexError = checkPortIndex('originPortIndex');
  if (checkOriginPortIndexError) {
    return checkOriginPortIndexError;
  }

  const res = [];
  for (const oldData of oldDataSource) {
    const newData = dataSource.find(d => Number(d.originPortIndex) === (Number(oldData.originPortIndex) + 1) && d.originName === oldData.originName);

    if (!newData) {
      return `The Port ({ ${keyToTitleMap.originPortIndex}: ${oldData.originPortIndex}, ${keyToTitleMap.originName}: ${oldData.originName} }) is not found.`
    }

    res.push({
      originPortIndex: oldData.originPortIndex,
      originName: oldData.originName,
      portIndex: newData.portIndex,
      name: newData.name,
    })
  }

  return res
    .sort((a, b) => Number(a.portIndex) - Number(b.portIndex))
    .map(d => {
      delete d.portIndex;
      return d;
    });
}

function getButtonTip(downloadProgress, uploadProgress) {
  if (!!downloadProgress) {
    return 'Downloading transform config now.';
  }

  if (!!uploadProgress) {
    return 'Uploading transform config now.';
  }
}

function getFileNameAndSuffix(openTransformData, isOnlyGetFileNameList = false) {
  const { fileName: file, transformedSnpInfo = [] } = openTransformData;
  // remove suffix
  const fileNameList = transformedSnpInfo.map(item => item.fileName.replace(/.s[0-9]{1,}p$/ig, ''));

  if (isOnlyGetFileNameList) {
    return fileNameList;
  }

  const fileName = getDefaultName({
    nameList: fileNameList,
    defaultKey: file.replace(/.s[0-9]{1,}p$/ig, '') || "",
    key: "",
    firstIndex: 1,
    delimiter: "(",
    endDelimiter: ")",
  })
  return {
    fileName,
    fileSuffix: (file.match(/.s[0-9]{1,}p$/ig, '') || [])[0] || "",
    fileNameList,
  }
}

export {
  PROCESSING_STATUS,
  fileNameErrorTip,
  generateDownloadSParameterList,
  generateTransformDataSource,
  parseTransformDataSource,
  getButtonTip,
  getFileNameAndSuffix,
  AVAILABLE_STATUS
}